<template>
  <Modal
    v-model="visible"
    title="编辑寄送信息">
    <Form
      ref="$form"
      :model="info"
      :rules="rules"
      :label-width="100">
      <FormItem
        prop="sendAddress"
        label="寄送地址：">
        <Input
          v-model="info.sendAddress"
          placeholder="请填写详细地址，精确到省市区-街道-门牌号"
        />
      </FormItem>
      <FormItem
        prop="diplomaPhoto"
        label="证件照：">
        <div
          v-if="info.diplomaPhoto"
          class="box-shadow"
          style="width: 200px;">
          <img :src="info.diplomaPhoto | formatDiplomaPhoto">
        </div>
        <Uploader
          :saveKey="[ 'user', 'photo' ]"
          :maxSize="1"
          placeholder="请上传蓝色背景的2寸清晰免冠电子照片"
          @on-uploaded="handlePhotoUploaded"
        />
      </FormItem>
    </Form>

    <div class="text-right" slot="footer">
      <Button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提交</Button>
    </div>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import { USER } from '../../../libs/namespace'
import Uploader from '../../../components/Uploader'

export default {
  name: 'sendInfoEditor',
  components: { Uploader },
  data () {
    const required = { required: true, message: '此为必填项', trigger: 'blur' }

    return {
      info: {
        sendAddress: '',
        diplomaPhoto: ''
      },
      rules: {
        sendAddress: [ required ],
        diplomaPhoto: [ required ]
      },
      loading: false
    }
  },
  handlers: {
    handlePhotoUploaded (url) {
      this.info.diplomaPhoto = url
    },
    async handleSubmit () {
      const valid = await this.$refs.$form.validate()
      if (!valid) return

      const flag = await window.confirm({
        title: '是否确认提交你的证书寄送信息？',
        content: `
          <p class="text-paragraph">请确保您填写的寄送地址与证件照片符合以下要求：</p>
          <p class="text-bold text-indent">1、寄送地址填写明确，精确到门牌号</p>
          <p class="text-bold text-indent text-paragraph">2、证件照片为2寸清晰免冠蓝色背景电子照片</p>
          <p class="text-paragraph text-bold">如因不符合以上问题导致寄送出现错误，责任将由您自行承担</p>
          <p class="text-bold">您填写的当前寄送信息将会作为默认寄送信息，对之后的所有寄送申请生效。您可以在证书寄出之前或下次申请寄送时修改默认信息。新的信息对已经寄送的证书无效</p>
        `
      })
      if (!flag) return
      try {
        this.loading = true
        await this.updateUser(this.info)
        window.toast.success('操作成功')
        this.update()
        this.visible = false
      } catch (error) {
        //
      } finally {
        this.loading = false
      }
    }
  },
  methods: {
    ...mapActions(USER, [ 'updateUser' ])
  }
}
</script>

